import React from 'react';
import { withTranslate } from 'react-redux-multilingual';
import { useNavigate, Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Zoom from 'react-medium-image-zoom';

import chromeExtension_1 from '../../../../../libraries/Images/chromeExtension_1.png';
import chromeExtension_2 from '../../../../../libraries/Images/chromeExtension_2.png';

function En(props) {
    const { translate } = props;
    return (
        <Box>
            <Typography variant="h5" gutterBottom id="chromeextension">
                1. {translate('chromeextension')}
            </Typography>
            <p>「RPA CLOUD」の 拡張機能はCSSセレクターを簡単に取得できる便利なツールです。CSS セレクターを取得したい場所を右クリックし、[Copy CSS Selector] を選択するだけです。</p>
            <p>手順：</p>
            <ol>
                <li>下記リンクよりインストールページへ移動します。</li>
                <p><a href='https://chrome.google.com/webstore/detail/rpa-cloud/hbbknhmpmbpeahaielmdciknifcodkdj?hl=en' target="_blank">を開きます</a>.</p>
                <li>[Add to Chrome]をクリックします。</li>
                <Zoom>
                    <img src={chromeExtension_1} width="75%" />
                </Zoom>
                <li>[Add extension]をクリックします。</li>
                <Zoom>
                    <img src={chromeExtension_2} width="75%" />
                </Zoom>
            </ol>
        </Box>
    );
}
export default withTranslate(En);